import { render, staticRenderFns } from "./crudPricesLists.vue?vue&type=template&id=599e72b2&"
import script from "./crudPricesLists.vue?vue&type=script&lang=js&"
export * from "./crudPricesLists.vue?vue&type=script&lang=js&"
import style0 from "./crudPricesLists.vue?vue&type=style&index=0&id=599e72b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports